module.exports = __webpack_public_path__ + "img/google-stadia-04.12d9f9c5.webp";